module.exports = __webpack_public_path__ + "img/receiver-bind-icon.918d71fe.png";